<template>
  <div class="wait-invoices-list">
    <div class="tip">
      本功能仅可开具使用中金支付时产生的手续费发票，发票开具方为中金支付公司，其中纸质专票不支持线上冲红，页面显示的“开票金额”
      为预估金额，实际开票金额请以发票信息为准
    </div>
    <div class="container" style="padding-top: 20px">
      <eui-btn type="primary" @click="applyForInvoice(false)" :disabled="selectData.length === 0">批量开票</eui-btn>
      <tableList
        :selectionShow="selectionShow"
        ref="table"
        class="margin-t10"
        rowKey="paymentRecordMonthId"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
        @handleSelect="handleSelect"
        @handleSelectAll="handleSelectionChange"
      >
        <template v-slot:month="slot">
          <span>{{dealMonth(String(slot.scope.row.month))}}</span>
        </template>
        <template v-slot:invoiceStatus="slot">
          <div class="flex-all-center">
            <span style="margin-right: 4px">{{ formatStatus(Number(slot.scope.row.invoiceStatus)) }}</span>
            <eui-tooltip
                    v-if="slot.scope.row.invoiceStatus === 13 || slot.scope.row.invoiceStatus === 23"
                    :content="slot.scope.row.msg"
                    placement="top"
                    style="cursor: pointer"
            >
              <div class="eicon-problem">
                <eui-icon icon="eicon-r-l-jingshi"  font-size="18px" class="nprmal" color="#C5C5C5"/>
                <eui-icon icon="eicon-r-jingshi"  font-size="18px" class="press" color="#C5C5C5"/>
              </div>
            </eui-tooltip>
            <eui-tooltip
                    v-if="slot.scope.row.invoiceStatus === 22"
                    :content="
              slot.scope.row.updateTime +
              ' ' +
              slot.scope.row.updateBy+
              ' 操作冲红'
            "
                    placement="top"
                    style="cursor: pointer"
                    fontSize="16px"
            >
              <div class="eicon-problem">
                <eui-icon icon="eicon-r-l-jingshi" color="#C5C5C5" font-size="18px" class="nprmal"/>
                <eui-icon icon="eicon-r-jingshi"  color="#C5C5C5"  font-size="18px" class="press"/>
              </div>
            </eui-tooltip>
          </div>
        </template>
        <template v-slot:operate="slot">
          <!--待开票 ： 可以申请开票-->
          <eui-btn
            type="text"
            color="#0064c8,#004898,#004898"
            v-if="slot.scope.row.invoiceStatus === 10"
            @click="applyForInvoice(slot.scope.row.paymentRecordMonthId)"
            >申请开票</eui-btn
          >
          <!--已冲红、开票失败 ： 可以重新开票-->
          <eui-btn
            type="text"
            color="#0064c8,#004898,#004898"
            v-if="
              slot.scope.row.invoiceStatus === 13 ||
              slot.scope.row.invoiceStatus === 22
            "
            @click="applyForInvoice(slot.scope.row.paymentRecordMonthId)"
            >重新开票</eui-btn
          >
        </template>
      </tableList>
      <div class="pagination flex-end">
        <el-pagination
          background
          :page-sizes="[10, 20,50,100,200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryData.pageNum"
          :page-size="queryData.pageSize"
          :total="queryData.pageTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <!--申请开票-->
    <apply-for-invoice-dialog
      :applyForInvoiceVisible.sync="applyForInvoiceVisible"
      :recordMonthIdList.sync="recordMonthIdList"
      :selectData.sync="selectData"
      v-if="applyForInvoiceVisible"
      ref="applyForInvoice"
    />
  </div>
</template>

<script>
import tableList from '../../components/common/e-table-list';
import api from '@/modules/projectA/api/pay';
import applyForInvoiceDialog from './common/applyForInvoiceDialog';
export default {
  components: {
    tableList,
    applyForInvoiceDialog,
  },
  data() {
    return {
      msgVisible:true,
      selectData:[],
      recordMonthIdList:[],//选中的数据
      applyForInvoiceVisible: false,
      selectionShow: true,
      tableData: [],
      tableLabel: [
        { label: '发票月份', param: 'month', align: 'center', width: '200',slot:'month' },
        {
          label: '开票状态',
          param: 'invoiceStatus',
          align: 'center',
          slot: 'invoiceStatus',
        },
        { label: '操作', param: '', align: 'center', slot: 'operate' },
      ],
      queryData: {
        pageNum: 1,
        pageSize: 10,
        pageTotal: 0,
      },
    };
  },
  methods: {
    changeMouse(){
      console.log('1111')
    },
    //清空选中
    clearSelected(){
      this.$refs.table.handleClearSelection();
    },
    handleSelectionChange(val,row){
      this.selectData = val.map(item=>item.paymentRecordMonthId);
      // console.log(this.recordMonthIdList,'单页整体 操作')
    },
    handleSelect(val){
      this.selectData = val.rows.map(item=>item.paymentRecordMonthId);
      // console.log(this.recordMonthIdList,'一个个 操作')
    },
    applyForInvoice(paymentRecordMonthId){
      if(paymentRecordMonthId){
        this.recordMonthIdList = [paymentRecordMonthId];
      }else{
        this.recordMonthIdList = this.selectData ;
      }
      if(this.recordMonthIdList.length > 0){
        this.applyForInvoiceVisible = true;
      }
    },
    dealMonth(month){
      const preMonth = month.substring(0,4);
      const sufMonth = month.substring(4,6);
     return preMonth + '-' +sufMonth;
    },
    //处理状态
    //待开票：10;  开票中：11;  已开票：12;   开票失败：13;  冲红中/处理中：21； 已冲红：22； 冲红失败：23
    formatStatus(invoiceStatus) {
      let status = '';
      switch (invoiceStatus) {
        case 10:
          status = '待开票';
          break;
        case 11:
          status = '开票中';
          break;
        case 12:
          status = '已开票';
          break;
        case 13:
          status = '开票失败';
          break;
        case 21:
          status = '处理中';
          break;
        case 22:
          status = '已冲红';
          break;
        case 23:
          status = '冲红失败';
          break;
      }
      return status;
    },
    handleCurrentChange(val) {
      this.queryData.pageNum = val;
      this.zhongJinQueryPage();
    },
    handleSizeChange(val) {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = val;
      this.zhongJinQueryPage();
    },
    async zhongJinQueryPage() {
      const res = await api.zhongJinQueryPage(this.queryData);
      if (res.success) {
        this.tableData = res.data.records || [];
        this.queryData.pageTotal = res.data.total;
      }
    },
  },
  mounted() {
    this.zhongJinQueryPage();
  },
};
</script>

<style scoped lang="scss">
.wait-invoices-list {
  .tip {
    width: 100%;
    background-color: #e8efff;
    padding: 15px 10px;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .eicon-problem{
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    .press{
      display: none;
    }
    transition: 0.6s ;
    &:hover{
      .nprmal{
        display: none;
      }
      .press{
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    &.icon-disabled{
      cursor: not-allowed;
      .nprmal{
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .press{
        display: none;
      }
    }
  }
}
</style>
